import { useServicesQuery } from '@/services/api';
import type { UseTasksOptions } from '../types';
import { transformBackfill } from '../utils/task-transform';

export function useTasks(options: UseTasksOptions) {
  const { workspaceId, page, limit, pageSize, enabled = true, state, type, refetchInterval } = options;

  const { data, isLoading, refetch, dataUpdatedAt } = useServicesQuery(
    'getBackfills',
    {
      params: { environment_id: workspaceId ?? 0 },
      query: {
        // `page` is 1-based in the UI (Pluma); the list endpoint's `page` is 0-based
        // (visibleOffset = limit * page), so convert at the wire boundary.
        page: page != null ? page - 1 : undefined,
        state: state ?? undefined,
        type: type ?? undefined,
        limit: pageSize ?? undefined,
      },
    },
    {
      enabled: enabled && workspaceId != null && workspaceId > 0,
      refetchInterval,
      select: (queryData) => ({
        ...queryData,
        backfills: (queryData?.backfills ?? []).map(transformBackfill),
      }),
    },
  );

  // `limit` caps results client-side (compact widgets); server-side paging uses `pageSize`.
  const tasks = (limit != null && limit > 0 ? data?.backfills.slice(0, limit) : data?.backfills) ?? [];

  return {
    tasks,
    meta: data?.meta,
    isLoading,
    refetch,
    dataUpdatedAt,
  };
}
